import { GET_SYSTEM_ADMIN_BUNDLED_SEATS } from './action';

// Initial State
const initialState = [];

const BundledSeatReducer = (state = initialState, action) => {
     switch (action.type) {
          case GET_SYSTEM_ADMIN_BUNDLED_SEATS: {
               return action.payload;
          }
          default:
               return state;
     }
};

export default BundledSeatReducer;
